// extracted by mini-css-extract-plugin
export default {"container":"ns2bSR","containerVetsNegative":"qTOUbZ","containerVetsPositive":"anqaGQ"};